import { apiRequest, getResource } from "../api/http";

// Subscribers to win back ("users" section): ended or cancelling paying
// subscribers, comeback offer (letter or written message, free days).
const BASE = "/api/admin/comeback";
const query = (params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "");
  return entries.length ? `?${new URLSearchParams(entries).toString()}` : "";
};

/** `{ status, days, page, q }`; rejects on failure. */
export const getComeback = (params) => getResource(`${BASE}${query(params)}`, { rethrow: true });
/** Exact email for a subscription (or an example): { email }. */
export const previewComeback = (options) =>
  apiRequest("post", `${BASE}/preview`, { data: options, rethrow: true, select: (data) => data.email });
/** { sent, gifted, skipped, failed }. */
export const sendComeback = (subscriptionIds, options) =>
  apiRequest("post", `${BASE}/send`, { data: { ...options, subscriptionIds }, rethrow: true });

export const apiError = (error) => error?.response?.data?.message || "";
